const COLUMNS = [
  { label: 'Period', numeric: false },
  { label: 'Submitted', numeric: true },
  { label: 'Confirmed', numeric: true },
  { label: 'Status', numeric: false },
  { label: 'Description', numeric: false },
  { label: 'Approver', numeric: false },
  { label: 'Paid', numeric: false },
];

/** Cell classes shared by the ledger rows and the current-period row. */
export const CELL = 'px-12 py-12 text-on-surface body-2';
export const MUTED_CELL = 'whitespace-nowrap px-12 py-12 text-on-surface-muted body-2';
export const DASH = '—';
export const MUTED_DASH = <span className="text-on-surface-muted">{DASH}</span>;

/** The prototype's columns, in its order, with Paid only when `showPaid`. */
export function hoursColumns(showPaid: boolean): typeof COLUMNS {
  return showPaid ? COLUMNS : COLUMNS.filter((column) => column.label !== 'Paid');
}

interface HoursTableProps {
  showPaid: boolean;
  /** The body rows, one `HoursRow` per submission. */
  children: React.ReactNode;
}

/**
 * The hours ledger as the prototype's table (`components/EngagementHub/HoursTab.tsx`),
 * header and cell type from `ChargeHistory`. One layout at every width, scrolled
 * sideways when narrow: a second, stacked layout would mount every row's
 * stateful actions twice.
 */
export default function HoursTable({ showPaid, children }: HoursTableProps): JSX.Element {
  return (
    <div className="overflow-x-auto [container-type:inline-size]">
      <table className="w-full border-collapse text-left">
        <thead>
          <tr className="border-b border-surface-border">
            {hoursColumns(showPaid).map(({ label, numeric }) => (
              <th
                key={label}
                scope="col"
                className={`px-12 py-8 text-on-surface-muted subtitle-2 ${numeric ? 'text-right' : ''}`}
              >
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
